import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Personal } from './components/Personal';
import { Experience } from './components/Experience';
import { Skills } from './components/Skills';
import { Values } from './components/Values';
import { Contact } from './components/Contact';
import { BackToTop } from './components/BackToTop';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-amber selection:text-cream" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Story data-id="element-3" />
        <Personal data-id="element-4" />
        <Experience data-id="element-5" />
        <Skills data-id="element-6" />
        <Values data-id="element-7" />
        <Contact data-id="element-8" />
      </main>

      <footer className="py-8 text-center text-charcoal/40 text-sm font-light border-t border-amber/10" data-id="element-9">
        <p data-id="element-10">© {new Date().getFullYear()} Jacob Palkin. Crafted with care.</p>
      </footer>

      <BackToTop data-id="element-11" />
    </div>;
}